import React from 'react';
import PropTypes from 'prop-types';
import { InputStyled, InputWrapper } from './styles';
import { Label, MessageAlert, MessageHelp } from '../../typography';

export const Input = InputStyled;

const FormInput = ({
  disabled,
  innerRef,
  name,
  type,
  label,
  value,
  values,
  errors,
  touched,
  onChange,
  handleChange,
  onBlur,
  handleBlur,
  onKeyDown,
  help,
  style,
  placeholder,
  readOnly,
  noMargin,
  autoFocus,
}) => {
  const error = !!errors[name] && !!touched[name];
  const success = !errors[name] && !!touched[name];

  const inputRef = React.useRef();
  React.useEffect(() => {
    if (autoFocus) {
      if (innerRef) {
        innerRef.current.focus();
      } else {
        inputRef.current.focus();
      }
    }
  }, [innerRef, autoFocus]);

  return (
    <InputWrapper style={style} error={error} help={help} noMargin={noMargin}>
      {label && <Label htmlFor={name}>{label}</Label>}
      <InputStyled
        success={success}
        error={error}
        help={help}
        readOnly={readOnly}
        aria-readonly={readOnly}
        aria-label={label}
        disabled={disabled}
        placeholder={placeholder}
        ref={innerRef ?? inputRef}
        type={type}
        id={name}
        name={name}
        value={value || values[name]}
        onChange={onChange || handleChange}
        onBlur={onBlur || handleBlur}
        onKeyDown={onKeyDown}
      />
      {help && !error && <MessageHelp>{help}</MessageHelp>}
      {error ? <MessageAlert>{errors[name]}</MessageAlert> : null}
    </InputWrapper>
  );
};

FormInput.propTypes = {
  style: PropTypes.object,
  readOnly: PropTypes.bool,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
  placeholder: PropTypes.string,
  help: PropTypes.string,
  label: PropTypes.string,
  type: PropTypes.string,
  value: PropTypes.string,
  name: PropTypes.string,
  innerRef: PropTypes.func,
  autoFocus: PropTypes.bool,
  // events
  onKeyDown: PropTypes.func,
  onChange: PropTypes.func,
  onBlur: PropTypes.func,
  // formik
  handleChange: PropTypes.func,
  handleBlur: PropTypes.func,
  values: PropTypes.object,
  touched: PropTypes.object,
  errors: PropTypes.object,
};

FormInput.defaultProps = {
  errors: {},
  values: {},
  touched: {},
  type: 'text',
};

export default FormInput;
